import { AnimationGeneratorType, Easing, motion } from "framer-motion";
import { JSX } from "react";

// Helper for page transitions
const pageVariants = {
    initial: {
        opacity: 0,
        x: "100vw",
        scale: 1
    },
    in: {
        opacity: 1,
        x: 0,
        scale: 1
    },
    out: {
        opacity: 0,
        x: "0vw",
        scale: 1
    }
};

const pageTransition = {
    type: "tween" as AnimationGeneratorType,
    ease: "anticipate" as Easing,
    duration: 0.5
};

export const PageTemplate = ({ children }: { children: JSX.Element | JSX.Element[] }) => <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    className="absolute w-full h-full"
>
    {children}
</motion.div>